/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentDynamicField, useSelectFieldSchema } from "cms/fields/dynamic-field";
import { ContentZone } from "cms/components/layout/index";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ComponentDebug } from "cms/fields/fields/field-component/edit/component-debug";
// import { Logger } from "cms/utils/log/logger";

const ComponentFieldEdit = () => {
    
    const { field } = useCurrentDynamicField();
    const values = field?.values;
    const settings = field?.settings;
    const name = field?.name;
    const schema = useSelectFieldSchema(name);
    
    // Logger.debug(`ComponentField [name:${name}] [type:${type}] [variant:${variant}]`, { field })
    // NOTE: the components array is always the first and only value in values
    const components = isArrayNotEmpty(values) ? values[0] : [];

    return (
        <div
            id='field-component-editor'
            className='component-editor'
        >
            
            <ContentZone />
            
            <ComponentDebug
                components={components}
                settings={settings}
                schema={schema}
            />
            
        </div>
    );
};
ComponentFieldEdit.displayName = "ComponentFieldEdit";
export { ComponentFieldEdit };
